import {Component, Input, Output, OnInit, TemplateRef} from '@angular/core';
import {ExcelExportEvent, GridComponent} from '@progress/kendo-angular-grid';
import {Workbook, WorkbookSheet} from '@progress/kendo-ooxml';
import {ExcelExportData} from '@progress/kendo-angular-excel-export';
import {process} from '@progress/kendo-data-query';
import {fileExcelIcon, filePdfIcon, SVGIcon} from "@progress/kendo-svg-icons";

@Component({
  selector: 'app-report-common',
  templateUrl: './report-common.component.html',
  styleUrls: ['./report-common.component.scss']
})
export class ReportCommonComponent implements OnInit {

  @Input() data: [] = [];
  @Input() pdfExport = true;
  @Input() headerTemplate: TemplateRef<any>;
  @Input() columns: [any];
  @Input() filename = 'report.pdf';
  @Input() tableState: {} = {};
  @Input() landscape = true;
  @Input() loading = true;
  @Input() excelExportOptions: {exportName: 'Export.xlsx', exportHeader: 'Exported Data', sheetName: 'Sheet 1', storeName: 'Store'};
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;

  constructor() {
    this.exportAllData = this.exportAllData.bind(this);
  }

  ngOnInit() {
  }

  exportToPDF(reportGrid: any) {
    this.loading = true;
    try {
      setTimeout(() => {
        reportGrid.saveAsPDF();
        this.loading = false;
      }, 100);
    } catch (ex) {
      console.error(`Problem creating PDF`);
    }
  }

  public exportAllData(): ExcelExportData {
    const items = this.data as any;
    const dataItems = items.data;
    const result: ExcelExportData = {
      data: process(dataItems, {}).data,
    };
    return result;
  }
  excelExported($event: ExcelExportEvent) {
    const sheet = $event.workbook.sheets[0];
    sheet.freezePane.rowSplit = 0;
    sheet.rows.unshift({
      cells: [
        {value: this.excelExportOptions.exportHeader, fontSize: 20, colSpan: 4}
      ]
    }, {
      cells: [
        {value: this.excelExportOptions.storeName, fontSize: 20, colSpan: 4}
      ]
    });
    sheet.name = this.excelExportOptions.sheetName;
  }

  exportToExcel(orderingGrid: any) {

    if(this.data == null) { return;}
    try {
      this.loading = true;
      setTimeout(() => {
        orderingGrid.saveAsExcel();

        this.loading = false;
      }, 100);
    } catch (ex) {
      this.loading = false;
    }
  }
}
